import { get } from 'lodash';
import React from 'react';
import { getLocalstorageToken } from 'src/context/AuthHelper';
import { ANTRAG_TYP, KOSTEN_ARTEN, KOSTEN_POSITION } from 'src/lib/constants/constant';
import { getKostenHinweisStruc } from 'src/utils/ausgabenFinanzierungHelper';
import SachkostenAntragLoewe, { getFormStrucSachkostenAntragLoewe } from './SachkostenAntragLoewe';

// import Schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
import { getVerbundPartnerName } from 'src/pages/private/online-antrag/application-helper-function/AppHelperfunctions';
const P = Schema.attributes;

export const GetSachkostenAntragLoewe = (application: any, hasCommentAusgabenUndFinanzierung?: boolean) => {
	const unternehmenId = get(getLocalstorageToken(), 'organisationId');
	const HinweisStruc = getKostenHinweisStruc(
		application,
		KOSTEN_POSITION.Ausgabe,
		KOSTEN_ARTEN.Sachkosten,
		ANTRAG_TYP.Antrag,
		hasCommentAusgabenUndFinanzierung,
		false,
	);

	const OrgaStruc = [
		{
			label: get(application, P.Antragstellende_Organisa_0074063902_licher_Name_Der_Organisation.path, `Antragsteller`),
			content: (
				<SachkostenAntragLoewe kostentraeger='Antragsteller' unternehmenId={unternehmenId} hasComment={hasCommentAusgabenUndFinanzierung} />
			),
			formStruc: getFormStrucSachkostenAntragLoewe(application, unternehmenId),
		},
	];
	const STRUC = get(application, P.Verbundpartner.path, []).map((ele: any, i: number) => {
		const vPId = get(ele, 'Verbundpartner.id');

		return {
			label: `${getVerbundPartnerName(ele, i)}`,
			content: <SachkostenAntragLoewe kostentraeger='Verbundpartner' unternehmenId={vPId} hasComment={hasCommentAusgabenUndFinanzierung} />,
			formStruc: getFormStrucSachkostenAntragLoewe(application, vPId),
		};
	});

	return [...HinweisStruc, ...OrgaStruc, ...STRUC];
};
